import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from '../persistenceEvents/persistenceEvent';
import { Issue } from '../../issue';


export class ActionItemIssueUpdated implements PersistenceEvent {

  public readonly type = SyncEventType.ACTION_ITEM_ISSUE_UPDATED;
  public issue: Issue;

  constructor(issue: Issue) {
    this.issue = issue;
  }
  // The payload of the event as a json-object
  getPayload(): object {
    return {
      id: this.issue.id,
      summary: this.issue.summary,
      description: this.issue.description,
      status: this.issue.status,
      issueType: this.issue.issueType
    };
  }
}
